import React from 'react';
import { Box, Text, Button, Flex, Icon } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaRocket, FaChartLine } from 'react-icons/fa';

const PromotionalDealPost = () => {
  const navigate = useNavigate();

  const handleCreateDeal = () => {
    navigate('/deal-flow');
  };

  return (
    <Box className="w-full bg-white rounded-lg border border-[#DBE2ED] shadow-sm">
      {/* Main content */}
      <Box className="p-4">
        <Flex direction="column" gap={4}>
          {/* Header */}
          <Box>
            <Text
              className="text-xl font-bold text-[#2F4B6E] mb-2"
              fontSize={{ base: 'lg', md: 'xl' }}
            >
              Ready to start raising funding?
            </Text>
            <Text
              className="text-gray-600 leading-relaxed"
              fontSize={{ base: 'sm', md: 'md' }}
            >
              You don't have an active deal yet. Create one now and get ready to
              connect with investors on Seed A Founder.
            </Text>
          </Box>

          {/* Benefits */}
          <Flex
            direction={{ base: 'column', sm: 'row' }}
            gap={3}
            className="bg-gray-50 p-3 rounded-lg"
          >
            <Flex alignItems="center" gap={2} className="text-sm text-gray-600">
              <Icon as={FaChartLine} color="#2F4B6E" />
              <Text>Connect with qualified investors</Text>
            </Flex>
            <Flex alignItems="center" gap={2} className="text-sm text-gray-600">
              <Icon as={FaRocket} color="#2F4B6E" />
              <Text>Accelerate your fundraising</Text>
            </Flex>
          </Flex>

          {/* CTA Button */}
          <Box alignSelf="flex-start">
            <Button
              onClick={handleCreateDeal}
              loadingText="Redirecting..."
              size="lg"
              w="auto"
              bg="#2F4B6E"
              color="white"
              fontWeight="semibold"
              py={3}
              px={6}
              borderRadius="lg"
              transition="all 0.2s"
              _hover={{
                bg: '#1a365d',
                transform: 'translateY(-1px)',
                boxShadow: 'lg',
                scale: '1.02',
              }}
              _active={{
                transform: 'translateY(0)',
                boxShadow: 'md',
              }}
            >
              Launch a Raise
            </Button>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default PromotionalDealPost;
